"use strict";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const customReportService = {
  createCustomReport: function (options) {
    return api.post(`/CustomReports`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteCustomReport: function (options) {
    return api.delete(`/CustomReports`, WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
  updateCustomReportTitle: function (options) {
    return api.put(`/CustomReports`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  deleteCustomReportDashboard: function (options) {
    return api.delete(`/CustomReports/Dashboards`, WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
  shiftCustomReportDashboard: function (options) {
    return api.put(`/CustomReports/Dashboards/Shift`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  updateCustomReportDashboard: function (options) {
    return api.put(`/CustomReports/Dashboards`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createCustomReportDashboard: function (options) {
    return api.post(`/CustomReports/Dashboards`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteCustomReportField: function (options) {
    return api.delete(`/CustomReports/Fields`, WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
  createCustomReportField: function (options) {
    return api.post(`/CustomReports/Fields`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  updateCustomReportField: function (options) {
    return api.put(`/CustomReports/Fields`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  shiftCustomReportField: function (options) {
    return api.put(`/CustomReports/Fields/Shift`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  downloadExample: function (options) {
    return api.get(
      `/CustomReports/${options.id}/DownloadExamples`,
      WithToken.headersToken({ params: {}, responseType: "blob" }, configuration.cookieName)
    );
  },
  updateCustomReportChartAxis: function (options) {
    return api.put(`/CustomReports/Fields/ChartAxis`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default customReportService;
